<template>
  <v-container>
    <v-skeleton-loader
      :loading="skeleton"
      class="mx-auto"
      max-height="970"
      type="list-item-three-line@6, actions, divider"
    >
      <form v-if="edit">      
        <v-container>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-select
                v-model="form.title_lookup_uid"
                :items="title"
                data-vv-name="title_lookup_uid"
                data-vv-as="title"            
                item-text="value"
                item-value="lookup_uid"
                label="Title"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field  
                v-model="form.alias"
                :error-messages="errors.collect('alias')"
                data-vv-name="alias"
                label="Alias"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field            
                v-model="form.name"
                v-validate="'required|max:255'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"
                label="Name"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field  
                v-model="email"
                v-validate="'required|email'"
                :error-messages="errors.collect('email')"
                data-vv-name="email"
                label="Email"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field
                v-model="ic"
                v-mask="mask"
                v-validate="'required'"
                disabled
                :error-messages="errors.collect('ic')"
                data-vv-name="ic"
                data-vv-as="ic number"
                label="IC Number"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-select
                v-model="form.gender_lookup_uid"
                :items="gender"
                data-vv-name="gender_lookup_uid"   
                data-vv-as="gender"
                item-text="value"
                item-value="lookup_uid"
                label="Gender"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-select
                v-model="form.ethnicity_lookup_uid"
                :items="ethnicity"
                data-vv-name="ethnicity_lookup_uid"
                data-vv-as="ethnicity"
                item-text="value"
                item-value="lookup_uid"
                label="Ethnicity"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-select
                v-model="form.marital_status_lookup_uid"
                :items="marital_status"
                data-vv-name="marital_status_lookup_uid"   
                data-vv-as="marital status"
                item-text="value"
                item-value="lookup_uid"
                label="Marital Status"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-select
                v-model="form.religion_lookup_uid"
                :items="religion"
                data-vv-name="religion_lookup_uid"
                data-vv-as="religion"
                item-text="value"
                item-value="lookup_uid"
                label="Religion"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-select
                v-model="form.dob_state_lookup_uid"
                :items="place_of_birth" 
                data-vv-name="dob_state_lookup_uid"       
                data-vv-as="place of birth" 
                item-text="value"
                item-value="lookup_uid"
                label="Place of Birth"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field
                v-model.number="form.no_of_dependent"
                v-validate="'required|dependentsValue'"
                :error-messages="errors.collect('dependents')"
                data-vv-name="dependents"
                data-vv-as="dependents"
                type="number"
                label="Dependents"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field
                v-model="mobilephoneNumber"
                v-validate="'required|phoneLength'"
                v-mask="['###-###-####', '###-####-####']"
                :error-messages="errors.collect('mobilephoneNumber')"
                data-vv-name="mobilephoneNumber"
                data-vv-as="mobile phone"
                label="Mobile Phone No."
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field
                v-model="addressLine1"
                v-validate="'required'"
                :error-messages="errors.collect('addressLine1')"
                data-vv-name="addressLine1"
                data-vv-as="address line  1"
                label="Correspondence Address 1"
                @input="addressLine1 = addressLine1.toUpperCase()"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field
                v-model="addressLine2"
                :error-messages="errors.collect('addressLine2')"
                data-vv-name="addressLine2"
                label="Correspondence Address 2"
                @input="addressLine2 = addressLine2.toUpperCase()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field
                v-model="addressLine3"
                :error-messages="errors.collect('addressLine3')"
                data-vv-name="addressLine3"
                data-vv-as="address line 3"
                label="Correspondence Address 3"
                @input="addressLine3 = addressLine3.toUpperCase()"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-autocomplete
                v-model="postcode"
                v-validate="'required'"
                :items="postcodes"
                :error-messages="errors.collect('postcodeId')"
                data-vv-name="postcodeId"
                data-vv-as="postcode" 
                item-text="postcode"
                item-value="postcode"
                value="postcode"
                label="Postcode"
                hide-selected
                @input="postCodeOnChanged(postcode)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-autocomplete
                v-show="postcode"
                v-model="cityId"
                v-validate="'required'"
                disabled
                :items="cities"
                :error-messages="errors.collect('cityId')"                
                data-vv-name="cityId"
                data-vv-as="city" 
                item-text="name"
                item-value="id"
                value="id"
                label="City"
                hide-selected
                @input="cityOnChanged(cityId)"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-autocomplete
                v-show="cityId"
                v-model="stateId"
                v-validate="'required'"
                disabled
                :items="states"
                :error-messages="errors.collect('stateId')"
                data-vv-name="stateId"
                item-text="name"
                item-value="id"
                value="id"
                label="State"
                hide-selected
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-file-input
                v-model="icFrontImage"
                accept="image/*"
                show-size
                label="IC Front Image"
                prepend-icon="photo"
                @change="handleFileUpload('icFrontImage')"
              />              
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-file-input
                v-model="icBackImage"
                accept="image/*"
                show-size
                label="IC Back Image"
                prepend-icon="mdi-camera"
                @change="handleFileUpload('icBackImage')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-img                
                v-if="icFrontImageUrl" 
                :src="icFrontImageUrl"
                alt="IC Front Image"
                width="270px"
                height="auto"
              />
              <v-progress-circular
                v-if="uploadingFront"
                indeterminate
                size="64"
                color="primary"
              />              
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-img 
                v-if="icBackImageUrl" 
                :src="icBackImageUrl"
                alt="IC Back Image"
                width="270px"
                height="auto"
              />
              <v-progress-circular
                v-if="uploadingBack"
                indeterminate
                size="64"
                color="primary"
              />              
            </v-col>
          </v-row>
        </v-container>
      </form>
      <div v-else>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-format-title
            </v-icon>
            <span class="font-weight-medium">Title:</span>
          </v-col>
          <v-col>
            {{ titleValue }}
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-human-male-female
            </v-icon>
            <span class="font-weight-medium">Gender:</span>
          </v-col>
          <v-col>
            {{ genderValue }}
          </v-col>
        </v-row>  
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-account-box-outline
            </v-icon>
            <span class="font-weight-medium">Name:</span>
          </v-col>
          <v-col>
            {{ person.name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-account-box
            </v-icon>
            <span class="font-weight-medium">Alias:</span>
          </v-col>
          <v-col>
            {{ person.alias }}
          </v-col>
        </v-row> 
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-email
            </v-icon>
            <span class="font-weight-medium">Email:</span>
          </v-col>
          <v-col>
            {{ employee.email }}
          </v-col>
        </v-row> 
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-account-group
            </v-icon>
            <span class="font-weight-medium">Ethnicity:</span>
          </v-col>
          <v-col>
            {{ ethnicityValue }}
          </v-col>
        </v-row>  
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-account-card-details
            </v-icon>
            <span class="font-weight-medium">IC Number:</span>
          </v-col>
          <v-col>
            <span>{{ icNumber | icFormat }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-church
            </v-icon>
            <span class="font-weight-medium">Religion:</span>
          </v-col>
          <v-col>
            {{ religionValue }}
          </v-col>
        </v-row>     
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-cake-variant
            </v-icon>
            <span class="font-weight-medium">Date Of Birth:</span>
          </v-col>
          <v-col>
            {{ person.dob }}
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-cellphone
            </v-icon>
            <span class="font-weight-medium">Mobile Phone:</span>
          </v-col>
          <v-col>
            {{ employee.mobilephone_number }}
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-home
            </v-icon>
            <span class="font-weight-medium">Address:</span>
          </v-col>
          <v-col>
            {{ address }}
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-heart
            </v-icon>
            <span class="font-weight-medium">Marital Status:</span>
          </v-col>
          <v-col>
            {{ maritalValue }}
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-city
            </v-icon>
            <span class="font-weight-medium">Place Of Birth:</span>
          </v-col>
          <v-col>
            {{ placeOfBirthValue }}
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-account-multiple-plus
            </v-icon>
            <span class="font-weight-medium">Dependents:</span>
          </v-col>
          <v-col>
            {{ person.no_of_dependent }}
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              fas fa-id-card
            </v-icon>
            <span class="font-weight-medium">Identity Cards:</span>            
          </v-col>
          <v-col>
            <v-img 
              v-if="icFrontImageUrl" 
              :src="icFrontImageUrl"
              alt="IC Front Image"
              width="270px"
              height="auto"
            />
          </v-col>
          <v-col>
            <v-img 
              v-if="icBackImageUrl" 
              :src="icBackImageUrl"
              alt="IC Back Image"
              width="270px"
              height="auto"
            />
          </v-col>
        </v-row>
      </div>  
      <v-card-actions v-if="$hasPermissionTo(['update whole persons']) || $store.state.isMyProfile">
        <v-spacer />
        <v-btn
          v-if="!edit"
          color="info"
          @click="editForm"
        >
          Edit
        </v-btn>
        <div v-else>
          <v-btn
            :disabled="progressing"
            text
            @click="edit = false"
          >
            Cancel
          </v-btn>
          <v-btn          
            :loading="progressing"
            color="success"
            @click="submitForm"
          >
            Update
          </v-btn>
        </div>
      </v-card-actions>
      <v-divider />
    </v-skeleton-loader>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    inject: ['$validator'],
    filters: {
      icFormat: function (value) {
        if (!value) return ''
      
        value = value.toString()
        return `${value.slice(0, 6)}-${value.slice(6, 8)}-${value.slice(8, 12)}`
      },
    },
    props: {
      personUid: {
        type: String,
        default: '',
      },
      employeeUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        uploadingFront: false,
        uploadingBack: false,
        skeleton: true,
        progressing: false,
        edit: false,
        person: {},
        employee: {},
        email: null,
        mask: '######-##-####',
        ic: null,
        mobilephoneNumber: null,
        address: null,
        postcode: null,
        postcodes: [],
        cities: [],
        cityIds: [],
        icFrontImage: null,
        icBackImage: null,
        form: {
          title_lookup_uid: '',
          dob_state_lookup_uid: '',
          marital_status_lookup_uid: '',
          religion_lookup_uid: '',
          ethnicity_lookup_uid: '',
          name: '',
          alias: '',
          no_of_dependent: 0,
          gender_lookup_uid: '',
        },
        dropdownDisabled: null,
      }
    },
    computed: {
      ...mapState('lookup', ['title', 'gender', 'ethnicity', 'religion', 'marital_status', 'place_of_birth']),   
      titleValue () {
        return (this.title.find(title => {
          return title.lookup_uid === this.person.title_lookup_uid
        }) || {}).value || ''
      },
      genderValue () {
        return (this.gender.find(gender => {
          return gender.lookup_uid === this.person.gender_lookup_uid
        }) || {}).value || ''
      },
      ethnicityValue () {
        return (this.ethnicity.find(ethnicity => {
          return ethnicity.lookup_uid === this.person.ethnicity_lookup_uid
        }) || {}).value || ''
      },
      religionValue () {
        return (this.religion.find(religion => {
          return religion.lookup_uid === this.person.religion_lookup_uid
        }) || {}).value || ''
      },
      maritalValue () {
        return (this.marital_status.find(marital => {
          return marital.lookup_uid === this.person.marital_status_lookup_uid
        }) || {}).value || ''
      },
      placeOfBirthValue () {
        return (this.place_of_birth.find(placeOfBirth => {
          return placeOfBirth.lookup_uid === this.person.dob_state_lookup_uid
        }) || {}).value || ''
      },
      icNumber () {
        return (this.person.identity_card || {}).ic_number || ''
      },
      cityList () {
        return this.cities.filter(city => {
          if (this.state) {
            return city.state_id === this.state
          }
          return city
        })
      },
      filteredCities () {
        return this.cities.filter(city => {
          return this.cityIds.includes(city.id)
        })         
      },
      icFrontImageUrl () {
        return this.employee.ic_front_url ? this.employee.ic_front_url : null
      },
      icBackImageUrl () {
        return this.employee.ic_back_url ? this.employee.ic_back_url : null
      },
    },
    watch: {
      personUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadPerson()            
          }
        },
      },
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadEmployee()
            this.loadPostcode()
            this.loadCity()
            this.loadCountry()
            this.loadState()
          }
        },
      },
      
    },
    mounted () {
      let scope = this

      this.$validator.extend('dependentsValue', {
        getMessage (field, args) {
          return 'Invalid Number of Dependents'
        },
        validate (value, args) {
          return scope.isValidDependents(value)
        },
      })

      this.$validator.extend('phoneLength', {
        getMessage (field, args) {
          return 'Invalid phone number (at least 10 numbers and max 11)'
        },
        validate (value, args) {
          return value.toString().length >= 12 && value.toString().length < 14
        },
      })
    }, 
    methods: {    
      loadEmployee () {
        this.$api.employees().show(this.employeeUid)
          .then(response => {
            this.employee = response.data
            this.address = this.checkCommaExist((this.employee || {}).address_line_1) + 
              ((this.employee || {}).address_line_2 ? this.checkCommaExist((this.employee || {}).address_line_2) : '') + 
              ((this.employee || {}).address_line_3 ? this.checkCommaExist((this.employee || {}).address_line_3) : '') +
              ((this.employee || {}).postcode ? this.checkCommaExist((this.employee || {}).postcode) : '') +
              ((this.employee || {}).address_city ? this.checkCommaExist(((this.employee || {}).address_city).name) : '') + 
              ((this.employee || {}).address_city ? ((this.employee || {}).address_city.state).name : '')
          })
      },
      loadPerson () {
        this.$api.persons().show(this.personUid)
          .then(response => {
            this.person = response.data          
          })
          .catch(() => {})
          .then(() => {
            this.skeleton = false
          })
      },
      loadPostcode () {
        this.$api.postcodes().list()
          .then((res) => {
            this.postcodes = res.data
          })
          .catch(() => {})
      },
      loadCity () {
        this.$api.cities().list()
          .then((res) => {
            this.cities = res.data
          })
          .catch(() => {})
      },
      loadState () {
        this.$api.states().list()
          .then((res) => {
            this.states = res.data
          })
          .catch(() => {})
      },
      loadCountry () {
        this.$api.countries().list()
          .then((res) => {
            this.countries = res.data
          })
          .catch(() => {})
      },
      postCodeOnChanged (postcodeValue) {
        this.cityId = null
        var cityID = this.postcodes.filter(p => {
          return p.postcode === postcodeValue
        })  

        this.cityIds = this.cities.filter(city => {
          return cityID.some(city2 => {
            return city2.city_id === city.id
          })
        }).map(city3 => {
          return city3.id
        })

        if (this.cityIds.length > 1) {
          this.dropdownDisabled = false
        } else {
          this.dropdownDisabled = true

          var cityId = this.postcodes.find(postcode => {
            return postcode.postcode === postcodeValue
          }).city_id

          if (cityId) {
            var cityObject = this.cities.find(city => {
              return city.id === cityId
            })
            this.cityId = cityObject.id

            if (cityObject) {
              var stateObject = this.states.find(state => {
                return state.id === cityObject.state_id
              })
              this.stateId = stateObject.id

              if (stateObject) {
                var countryObject = this.states.find(state => {
                  return state.country_id === stateObject.country_id
                })
                this.countryId = countryObject.id
              }
            }
          }          
        }
      },
      cityOnChanged (cityId) {
        var cityObj = this.cities.find(city => {
          return city.id === cityId
        })

        if (cityObj) {
          var stateObj = this.states.find(state => {
            return state.id === cityObj.state_id
          })
          this.stateId = stateObj.id

          if (stateObj) {
            var countryObject = this.states.find(state => {
              return state.country_id === stateObj.country_id
            })
            this.countryId = countryObject.id
          }
        }
      },
      handleFileUpload (type) {
        const input = type === 'icFrontImage' ? this.icFrontImage : this.icBackImage
        const file = input || null

        if (file) {
          this.uploadImage(file, type)
        }
      },
      uploadImage (file, type) {
        if (type === 'icFrontImage') {
          this.uploadingFront = true
          const formData = new FormData()
          formData.append('frontIc', file)

          this.$api.employees().uploadFrontIc(this.employeeUid, formData)
            .then(res => {
              if (res.status >= 200 && res.status < 300) {   
                if (this.isCurrentUser) {
                  this.$store.dispatch('getCurrentUser')
                }
                this.savedImages()                
              }          
            })
            .catch(() => {
              this.uploadingFront = false
              this.$snack({
                color: 'error',
                message: 'Photo upload failed, please try again',
              })
            }) 
        } else if (type === 'icBackImage') {
          this.uploadingBack = true
          const formData = new FormData()
          formData.append('backIc', file)

          this.$api.employees().uploadBackIc(this.employeeUid, formData)
            .then(res => {
              if (res.status >= 200 && res.status < 300) {   
                if (this.isCurrentUser) {
                  this.$store.dispatch('getCurrentUser')
                }
                this.savedImages()  
              }          
            })
            .catch(() => {
              this.uploadingBack = false
              this.$snack({
                color: 'error',
                message: 'Photo upload failed, please try again',
              })
            })
        }
      },
      savedImages () {
        this.loadEmployee()
        this.uploadingFront = false
        this.uploadingBack = false
        this.$snack({
          message: 'Image uploaded successfully!',
        })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            Promise.all([
              this.$api.persons().update(this.personUid, this.form),
              // this.$api.employees().updateEmail(this.employeeUid, this.prepareEmailData()),
              this.$api.employees().update(this.employee.employee_uid, this.prepareFormData()),
              // this.$api.identityCards().update(this.person.person_uid, { ic_number: this.ic.replace(/-/g, '') }),
            ])
              .then(([person, employee]) => {
                if (person.status >= 200 && person.status < 300) {
                  Object.keys(this.form).map(key => {
                    this.$set(this.person, key, this.form[key])
                  })

                  this.edit = false

                  this.$snack({
                    message: person.data.status,
                  })
                }
              }).catch((e) => {
                if (e.response.status === 409) {
                  this.$snack({ 
                    color: 'error',
                    message: e.response.data.message, 
                  })
                }
              })
              .then(() => {
                this.progressing = false
                this.loadEmployee()
                this.loadPerson()
              })
          })
      },
      prepareFormData () {
        return {          
          mobilephone_number: this.mobilephoneNumber,
          address_line_1: this.addressLine1,
          address_line_2: this.addressLine2,
          address_line_3: this.addressLine3,
          postcode: this.postcode,
          address_city_id: this.cityId,
          address_state_id: this.stateId,
          address_country_id: this.countryId,
          email: this.email,          
        }
      },
      prepareEmailData () {
        if (this.employee.email) {
          if (this.email) {
            return {
              email: this.email,
            }
          }
          return {
            email: this.employee.email,
          }
        }

        return {
          email: this.email,
        }
      },
      editForm () {
        Object.keys(this.form).map(key => {
          this.form[key] = this.person[key]
        })

        this.email = this.employee.email
        this.ic = this.person.identity_card.ic_number
        this.mobilephoneNumber = this.employee.mobilephone_number
        this.addressLine1 = this.employee.address_line_1
        this.addressLine2 = this.employee.address_line_2
        this.addressLine3 = this.employee.address_line_3
        this.postcode = this.employee.postcode
        this.cityId = this.employee.address_city_id
        this.stateId = this.employee.address_state_id

        this.edit = true
      },
      isValidDependents (value) {
        return value >= 0
      },
      checkCommaExist (string) {
        if (!string) {
          return 'N/A'
        }

        if (string.substr(string.length - 1) === ',') {
          return string
        } else {
          return string + ','
        }
      },
    },
  }
</script>
